import { render, staticRenderFns } from "./ModalNeedCoins.vue?vue&type=template&id=7f96f0f9&scoped=true&"
import script from "./ModalNeedCoins.vue?vue&type=script&lang=js&"
export * from "./ModalNeedCoins.vue?vue&type=script&lang=js&"
import style0 from "./ModalNeedCoins.vue?vue&type=style&index=0&id=7f96f0f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f96f0f9",
  null
  
)

export default component.exports